import Icon from "Components/Icons/Icon";
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { tourElementsIds } from "tour/tourElementsIds";

interface DeleteItemModalProps {
  show?: boolean;
  onCloseClick?: () => void;
  onStartFromScratchClick: () => void;
  onUsePresetClick: () => void;
  isInvoice?: boolean;
}

const HowCreateQuotesModal: React.FC<DeleteItemModalProps> = ({
  show,
  onStartFromScratchClick,
  onUsePresetClick,
  onCloseClick,
  isInvoice,
}) => {
  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      contentClassName="br-7"
    >
      <div id={tourElementsIds.quoteTour2}>
        <ModalHeader className="bg-greyF5 p-3 " toggle={onCloseClick}>
          <span className="text-black2D fs-16 fw-medium font-primary">
            {isInvoice ? "Create a New Invoice" : "Create a New Quote"}
          </span>
        </ModalHeader>
        <ModalBody className="p-3">
          <h6 className="fs-14 text-grey89 fw-normal font-primary">
            Choose how you’d like to begin. You can start fresh and build your
            quote step by step, or save time by using one of your preset quote
            templates.
          </h6>
          <div className="d-flex gap-3 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn bg-greyF5 d-flex flex-column justify-content-center align-items-center gap-2 py-4 w-50 rounded-3 btn-press-effect"
              data-bs-dismiss="modal"
              onClick={onStartFromScratchClick}
            >
              <Icon
                name="UsePreset"
                className="w-6 h-4 "
                width={40}
                height={40}
              />

              <span className="text-black2D fs-14 fw-medium font-primary">
                Start from Scratch
              </span>
            </button>
            <button
              type="button"
              className="btn bg-greyF5 d-flex flex-column justify-content-center align-items-center gap-2 py-2 w-50 rounded-3 btn-press-effect"
              id="delete-record"
              onClick={onUsePresetClick}
            >
              <Icon
                name="StartFromScratch"
                className="w-6 h-4 "
                width={40}
                height={40}
              />
              <span className="text-black2D fs-14 fw-medium font-primary">
                Use Preset Quote
              </span>
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default HowCreateQuotesModal;
